import { Tag } from './tag';

export class TagEnum {
  public static Name = new Tag('Api-User-Personal-Name', 'name');
  public static Surname = new Tag('Api-User-Personal-Surname', 'surname');
  public static Phone = new Tag('Api-User-Personal-Phone', 'phone');
  public static Email = new Tag('Api-User-Personal-Nick', 'email');
  // public static Avatar = new Tag('Avatar', 'avatar');

  public static Language = new Tag('Api-General-Language', 'language');
  public static TimeZone = new Tag('Api-General-Iana-Timezone-Name', 'timeZone');
  public static MapProvider = new Tag('Teagle-Map', 'map');

  public static RedirectUrl = new Tag('Teagle-AbsoluteLogoutRedirectUrl', null);
  public static ControlledInputs = new Tag('Api-Client-ControlledInputs', null);
  
}
